import keys from "lodash/keys";
import { defineAsyncComponent } from "vue";

const files = import.meta.glob("@public/flags/**/*.svg");

const defineAsyncFlagComponent = (fileName: string) => {
  return keys(files).some(file => file.includes(`flags/${fileName}.svg`))
    ? defineAsyncComponent(() => import(`@public/flags/${fileName}.svg`))
    : null;
};

export const flagComponentManager = (flagNames: string[]) => {
  return flagNames.reduce(
    (acc, name) => {
      acc[name] = defineAsyncFlagComponent(name);
      return acc;
    },
    {} as Record<string, ReturnType<typeof defineAsyncComponent> | null>
  );
};

export const generateFlags = (uniqueFlags: string[]) => {
  return flagComponentManager(uniqueFlags);
};
